const partners = {
  ENVIOS_NOW: 'envios now',
  FAZT: 'fazt'
}

const partnerLabels = {
  ENVIOS_NOW: 'Envios Now',
  FAZT: 'Fazt'
}

const partnerSelectOptions = [
  { text: partnerLabels.ENVIOS_NOW, value: partners.ENVIOS_NOW },
  { text: partnerLabels.FAZT, value: partners.FAZT }
]

const partnerDeliveryStatusLabels = {
  [partners.ENVIOS_NOW]: {
    pendiente: 'Pendiente',
    'por entregar': 'Por Entregar',
    entregado: 'Entregado',
    rechazado: 'Rechazado',
    cancelado: 'Cancelado'
  },
  [partners.FAZT]: {
    'Sin comuna': 'Sin comuna',
    Creado: 'Creado',
    'Etiqueta impresa': 'Etiqueta impresa',
    'En deposito': 'En deposito',
    'En ruta': 'En ruta',
    Completado: 'Completado',
    'No completado': 'No completado',
    Cancelado: 'Cancelado',
    Duplicado: 'Duplicado',
    'No aceptado': 'No aceptado',
    Siniestrado: 'Siniestrado',
    'En Devolución': 'En Devolución',
    Devuelto: 'Devuelto',
    'No Devuelto': 'No Devuelto',
    Retirado: 'Retirado'
  }
}

export default {
  partners,
  partnerLabels,
  partnerSelectOptions,
  partnerDeliveryStatusLabels
}
